module.exports = __webpack_public_path__ + "img/tabs-img.30838c3a.webp";